import { zodResolver } from '@hookform/resolvers/zod';
import { Pegasus } from 'corso-types';
import { useForm, useFormContext } from 'react-hook-form';
import { z } from 'zod';
import { automationFormDataSchema, UseFormTypes } from '~/types';
import { useEventDefaultParams } from './useEventDefaultParams';

const defaultEventType = Pegasus.EventType.modifyResolutionWindow;

export type AutomationFormValues = z.infer<typeof automationFormDataSchema>;

export function useAutomationForm({
  values,
}: {
  values?: AutomationFormValues;
}) {
  const eventDefaultParams = useEventDefaultParams();
  return useForm({
    resolver: zodResolver(automationFormDataSchema),
    values,
    defaultValues: {
      name: '',
      hook: Pegasus.hooksForEvent[defaultEventType][0], // first element is considered default
      isEnabled: true, // default to enabled
      event: {
        type: defaultEventType,
        params: eventDefaultParams[defaultEventType](),
      },
      booleanExpression: 'all',
      conditions: [],
    },
  });
}

export function useAutomationFormContext() {
  type FormTypes = UseFormTypes<typeof useAutomationForm>;
  return useFormContext<
    FormTypes['FieldValues'],
    FormTypes['Context'],
    FormTypes['TransformedValues']
  >();
}
